export default "__VITE_ASSET__oC$LED_8__"